import React, { useState } from "react";
import { Box, TextField, IconButton, MenuItem, InputAdornment, useTheme, useMediaQuery } from "@mui/material";
import { Call, Close, CallEnd } from "@mui/icons-material";
import { useCallContext } from "../../context/CallContext";

const MessagePhoneChannel = ({
  selectedChannel,
  conversationId,
  userPhone = "Seu Telefone", // Telefone do perfil do usuário
  customerPhones = [], // Telefones disponíveis do cliente
  origin,
  setOrigin,
  destination,
  setDestination,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [customOrigin, setCustomOrigin] = useState("");
  const [customDestination, setCustomDestination] = useState("");

  const { outgoingCall, startOutgoingCall, endOutgoingCall } = useCallContext();

  const handleCall = () => {
    const finalOrigin = origin === "custom" ? customOrigin : origin;
    const finalDestination = destination === "custom" ? customDestination : destination;

    if (finalOrigin && finalDestination) {
      startOutgoingCall({
        channelId: Number(selectedChannel) || null,
        leadId: Number(conversationId) || null,
        fromNumber: finalOrigin === "computer" ? undefined : finalOrigin,
        toNumber: finalDestination,
      });
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        borderRadius: "8px",
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        gap: 1,
      }}
    >
      {/* Campo para selecionar origem ou digitar manualmente */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {origin !== "custom" ? (
          <TextField
            select
            label="Origem"
            value={origin}
            onChange={(e) => setOrigin(e.target.value)}
            fullWidth
            SelectProps={{
                MenuProps: {
                  getContentAnchorEl: null, // Remove o ancoramento padrão
                  anchorOrigin: {
                    vertical: "top", // Exibe acima
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "bottom", // Alinha corretamente
                    horizontal: "left",
                  },
                },
              }}
          >
            <MenuItem value="computer">Computador</MenuItem>
            <MenuItem value={userPhone}>Meu Telefone ({userPhone})</MenuItem>
            <MenuItem value="custom">Outro</MenuItem>
          </TextField>
        ) : (
          <TextField
            label="Digite o número de origem"
            value={customOrigin}
            onChange={(e) => setCustomOrigin(e.target.value)}
            fullWidth
            InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setOrigin("computer")}>
                      <Close />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
          />
        )}
      </Box>

      {/* Campo para selecionar destino ou digitar manualmente */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {destination !== "custom" ? (
          <TextField
            select
            label="Destino"
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
            fullWidth
            SelectProps={{
                MenuProps: {
                  getContentAnchorEl: null, // Remove o ancoramento padrão
                  anchorOrigin: {
                    vertical: "top", // Exibe acima
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "bottom", // Alinha corretamente
                    horizontal: "left",
                  },
                },
              }}
          >
            {customerPhones.map((phone, index) => (
              <MenuItem key={index} value={phone}>
                {phone}
              </MenuItem>
            ))}
            <MenuItem value="custom">Outro</MenuItem>
          </TextField>
        ) : (
          <TextField
            label="Digite o número de destino"
            value={customDestination}
            onChange={(e) => setCustomDestination(e.target.value)}
            fullWidth
            InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setDestination("")}>
                      <Close />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
          />
        )}
      </Box>

      {/* Botão de Ligar */}
      <IconButton
        onClick={outgoingCall ? endOutgoingCall : handleCall}
        disabled={
            (origin === "custom" && !customOrigin) ||
            (destination === "custom" && !customDestination) ||
            !origin ||
            !destination
        }
        sx={{
            backgroundColor: outgoingCall ? theme.palette.error.main : theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: "50%",
            padding: isMobile ? "12px" : "16px",
            "&:hover": {
            backgroundColor: outgoingCall
                ? theme.palette.error.dark
                : theme.palette.primary.dark,
            },
        }}
        >
        {outgoingCall ? (
            <CallEnd fontSize="large" /> // Ícone para encerrar chamada
        ) : (
            <Call fontSize="large" /> // Ícone para iniciar chamada
        )}
        </IconButton>
    </Box>
  );
};

export default MessagePhoneChannel;
